module.exports = __webpack_public_path__ + "img/Like-hollow.f5d69395.svg";